var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.9831 49.5301C65.0243 53.1315 62.4621 57.6333 58.3851 57.6333H5.31434C1.22946 57.6333 -1.32097 53.1245 0.716325 49.5301L27.252 2.69987C29.2943 -0.903222 34.4094 -0.896693 36.448 2.69987L62.9831 49.5301ZM31.85 39.848C29.0405 39.848 26.7629 42.1663 26.7629 45.026C26.7629 47.8858 29.0405 50.204 31.85 50.204C34.6596 50.204 36.9372 47.8858 36.9372 45.026C36.9372 42.1663 34.6596 39.848 31.85 39.848ZM27.0202 21.2359L27.8406 36.5447C27.8789 37.2611 28.4609 37.8219 29.1657 37.8219H34.5344C35.2392 37.8219 35.8211 37.2611 35.8595 36.5447L36.6798 21.2359C36.7213 20.4621 36.116 19.8115 35.3547 19.8115H28.3452C27.5839 19.8115 26.9787 20.4621 27.0202 21.2359Z",
    fill: "#E82A2B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.3751e471.svg";
export { ForwardRef as ReactComponent };